<template>
  <div class="market-chart-menu">
    <div class="type" @click="chartTypeChange">
      <ilines v-if="chartType === 'lines'" />
      <icandles v-if="chartType === 'candles'" />
    </div>
    <div class="tickers">
      <div
        class="ticker"
        v-for="(ct, i) in comparables"
        :key="ct.id"
        :class="{ selected: selectedAll.indexOf(ct.apiName) > -1 }"
        :style="{ 'background-color': colors[i] }"
        @click="toggleTicker(ct.apiName, colors[i])"
      >
        {{ $i18n.locale == 'en' && ct.title_en ? ct.title_en : ct.title_ru }}
      </div>
    </div>
  </div>
</template>

<script>
import icandles from '@/components/icons/chart-candles'
import ilines from '@/components/icons/chart-lines'

export default {
  components: {
    ilines,
    icandles,
  },
  props: {
    chartType: String,
    ticker: String,
    comparables: Array,
    selected: Array,
  },
  computed: {
    selectedAll() {
      return this.selected.concat([this.ticker])
    },
    colors() {
      return ['#007AFF', '#AF52DE', '#E5B200', '#FF7A00']
    },
  },
  methods: {
    chartTypeChange() {
      if (this.chartType === 'lines') {
        const cmpbls = this.selected.map((el) => el)
        for (let ti = 0; ti < cmpbls.length; ti++) {
          this.$emit('tickerclick', cmpbls[ti])
        }
        this.$emit('chartTypeChange', 'candles')
      } else this.$emit('chartTypeChange', 'lines')
    },
    toggleTicker(ct, color) {
      if (this.chartType !== 'lines') this.$emit('chartTypeChange', 'lines')
      this.$emit('tickerclick', ct, color)
    },
  },
}
</script>

<style lang="scss">
.market-chart-menu {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 799;

  .tickers {
    display: inline-block;
    background-color: white;
    border-radius: 15px;
  }
  .ticker,
  .type {
    &:hover {
      cursor: pointer;
    }
  }
  .ticker {
    display: inline-block;
    border-radius: 10px;
    height: 20px;
    background-color: white;
    vertical-align: middle;
    line-height: 1em;
    padding: 4px 8px;
    font-size: 12px;
    color: black;
    // border: 2px solid;
    position: relative;
    z-index: 2;

    &:not(:last-child) {
      margin-right: 12px;
    }

    $border-weight: 2px;
    &:not(.selected):after {
      content: '';
      position: absolute;
      display: block;
      width: calc(100% - #{$border-weight * 2});
      height: calc(100% - #{$border-weight * 2});
      left: $border-weight;
      top: $border-weight;
      padding: 2px 6px;
      border-radius: 10px;
      background-color: white;
      z-index: -1;
    }
    &.selected {
      color: white;
    }
  }
  .type {
    display: inline-block;
    margin-right: 20px;
  }
}
</style>
